const Constants = {

    DEFAULT: "Default"
}

export {Constants};